import { useContext, useState } from 'react'
import { apiClient } from '../../api/ApiClient'
import { ChatContext } from '../context/ChatContext'

export function useChatManualSupportMutation() {
  const { chatId, setManualSupportPromptOpened, setManualSupportConfirmationOpened } = useContext(ChatContext)
  const [isPending, setIsPending] = useState(false)

  return {
    isPending,
    mutate: async () => {
      setIsPending(true)

      await apiClient.chats.assist(chatId).finally(() => {
        setIsPending(false)
      })

      setManualSupportPromptOpened(false)
      setManualSupportConfirmationOpened(true)
    },
  }
}
